import { defaulted, record, string, boolean, type } from 'superstruct';
export const Sale = defaulted(type({
    enabled: boolean(),
    suffix: string(),
    cart_message: defaulted(string(), ''),
    variantsMap: record(string(), boolean())
}), {
    enabled: false,
    suffix: '',
    cart_message: '',
    variantsMap: {}
});
// Reusable defaults (frozen to avoid accidental mutation)
export const SALE_DEFAULTS = Object.freeze({
    enabled: false,
    suffix: '',
    cart_message: '',
    variantsMap: {}
});
